<script>
import {mapActions, mapState} from 'vuex'
import ContentDetailWrapper from '@/components/common/content/ContentDetailWrapper'

export default {
  extends: ContentDetailWrapper,

  computed: {
    ...mapState('requests/money/compensations', {
      'error': 'detailError',
      'loading': 'detailLoading',
      'instance': 'detail'
    })
  },

  methods: {
    ...mapActions('requests/money/compensations', [
      'retrieve'
    ]),
  }
}
</script>
